import { render, staticRenderFns } from "./elsi-score.vue?vue&type=template&id=6005d77d"
import script from "./elsi-score.vue?vue&type=script&lang=js"
export * from "./elsi-score.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports